import Vue from 'vue';
import Router from 'vue-router';
import notFound from '../javascript/components/404.vue'
import home from '../javascript/components/home.vue'
import parceiros from '../javascript/components/parceiros.vue';
import perguntasfrequentes from '../javascript/components/perguntasfrequentes.vue';
import candidate from '../javascript/components/candidate/candidate.vue';
import Receipt from "../javascript/components/receipt/Receipt.vue";
import Deposit from "../javascript/components/deposit/Deposit.vue";

 Vue.use(Router);


export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: home
        },
        {
            path: '*',
            name: '404',
            component: notFound
        },
        {
            path: '/parceiros',
            name: 'parceiros',
            component: parceiros
        },
        {
            path: '/perguntas-frequentes',
            name: 'perguntasfrequentes',
            component: perguntasfrequentes
		},
		{
			path: '/:candidate',
			name: 'candidate',
			component: candidate
		},
		{
			path: '/:candidate/recibo/:digest',
			name: 'receipt',
			component: Receipt,
		},
		{
			path: '/:candidate/deposito/:depositId',
			name: 'deposit',
			component: Deposit,
		},
    ],
    scrollBehavior (to, from, savedPosition) {

        if(to.hash ){
            return {
                selector: to.hash,
                offset:{x:0, y:88}
              }
        }else{
            return { x: 0, y: 0 }
        }
    }
})



// WEBPACK FOOTER //
// ./_source/router/index.js